@if (showIntro) {
<div class="intro-overlay" #introOverlay>
  <video class="intro-overlay__video"
    #introVideo
    muted
    loop
    autoplay
    playsinline
    preload="auto"
    poster="intro-video_web_poster.jpeg">
    <source src="intro-video_web.webm" type="video/webm" />
    <source src="intro-video_web.mp4" type="video/mp4" />
  </video>
  <!-- White background with the lockup punched out of it. Fades in over the
         still-playing video so the outside-of-letters area crossfades from
         video to white without a hard mask switch. -->
  <div class="intro-overlay__cover" #introCover></div>
</div>
}

<app-nav></app-nav>
<div class="smooth-wrapper" id="smooth-wrapper">
  <div class="smooth-content" id="smooth-content">
    <main class="main">
      <router-outlet #outletRef="outlet"></router-outlet>
    </main>
    <app-site-footer></app-site-footer>
  </div>
</div>

<div class="loader__panel page-wipe-blue"></div>
<div class="loader__panel page-wipe-white">
  <svg>
  <defs>
    <filter id="ripple-filter">
      <feImage x="40" y="50" width="0%" height="0%" result="rippleImage" />

      <feDisplacementMap id="displacement-map"
                         xChannelSelector="R"
                         yChannelSelector="G"
                         in="SourceGraphic"
                         in2="rippleImage"
                         result="displacementMap"
                         color-interpolation-filters="sRGB"
                         scale="0" />

      <feComposite operator="in" in2="rippleImage"></feComposite>
    </filter>
  </defs>

  <g id="logo">
    <image fetchpriority="high"
            id="logo-image"
           width="162.81"
           height="141.5"
           xlink:href="../../assets/logos/router_animation_logo.svg" />

    <image fetchpriority="high"
            id="logo-overlay"
           width="162.81"
           height="141.5"
           xlink:href="../../assets/logos/router_animation_logo.svg"
           filter="url(#ripple-filter)" />
  </g>
</svg>

</div>
